import { css } from 'styled-components';
import dt from '../../../shared/theme';
import { darken } from '../../../shared/color';

const Ul = css`
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;

  li {
    text-align: center;
    color: ${props => dt(props).theme.primaryColor};
    font-weight: ${props => dt(props).theme.fontWeightHeavy};
    font-size: 15px;

    span.count {
      letter-spacing: -.05em;
    }

    a {
      span {
        position: relative;
        color: ${props => dt(props).theme.secondaryColor};
      }

      &:hover {
        text-decoration: none;

        span {
          color: ${props => darken(dt(props).theme.secondaryColor, 10)};
        }
      }

      &:focus {
        outline: none;
      }
    }
  }
`;

export default Ul;
